<template>
  <DsProcessSection
    title=""
    title-id="release-process-title"
    tag=""
    layout="list"
    card-variant="expanded"
    :steps="steps"
    class="release-process"
  >
    <template #title>¿Cómo es el <span class="hl">proceso?</span></template>
    <template #title-request>
      <span class="release-process__request-title">
        <span>Solicita la{{ ' ' }}</span>
        <span>"Carta Instrucción para Cancelar la Hipoteca"{{ ' ' }}</span>
        <span>y envía datos{{ ' ' }}</span>
        <span>de la notaría.</span>
      </span>
    </template>
    <template #step-request>
      <p>
        <strong>Envía un correo a:</strong>{{ ' ' }}
        <a :href="supportResources.mortgageEmail">cancelacionhipoteca@hircasa.com.mx</a>
      </p>
      <p>
        Para emitir la Carta de Cancelación de Hipoteca, con la cual podrás iniciar el trámite de liberación de
        garantía, es necesario enviar la siguiente información:
      </p>
      <ul>
        <li>Nombre completo del titular.</li>
        <li>Número(s) de contrato que desea liberar.</li>
        <li>
          En caso de solicitar la cancelación de hipoteca bajo la modalidad<br
            class="release-process__desktop-break"
          />“Condicionada a pago”, los contratos deberán encontrarse al corriente.
        </li>
        <li>Datos de la notaría que realizará el trámite:</li>
        <li>Número de notaría.</li>
        <li>Nombre del notario.</li>
        <li>Ciudad.</li>
      </ul>
      <p>
        <strong>Importante:</strong> La solicitud deberá enviarse desde el mismo correo electrónico que se encuentra
        registrado en HIR Casa.
      </p>
    </template>
  </DsProcessSection>
</template>
<script setup lang="ts">
import DsProcessSection from '../components/DsProcessSection.vue'
import { supportResources } from '../data/supportResources'
const steps = [
  { id: 'quote', title: 'Cotizar notaría' },
  { id: 'request', title: 'Solicita la “Carta Instrucción para Cancelar la Hipoteca” y envía datos de la notaría.' },
  {
    id: 'letter',
    title: 'Emisión de Documentación',
    description:
      'Te haremos entrega de la “Carta de instrucciones de cancelación de hipoteca”, la cual deberás presentar en la notaría elegida.'
  },
  {
    id: 'completion',
    title: 'Finalización',
    description: 'Una vez entregada la carta de liberación, la notaría se encargará de concluir el proceso ante el RPP.'
  }
]
</script>
<style scoped>
.release-process {
  padding: 0;
  background: transparent;
}
.release-process a {
  overflow-wrap: anywhere;
  color: var(--ds-purple-500);
}
.release-process__request-title {
  display: block;
  font-size: 14px;
  line-height: 16px;
}
.release-process ul {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.release-process__desktop-break {
  display: none;
}
@media (min-width: 1025px) {
  .release-process__desktop-break {
    display: inline;
  }
}
@media (max-width: 599px) {
  .release-process ul {
    gap: 20px;
  }
  .release-process__request-title {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 120px;
  }
  .release-process__request-title > span {
    display: block;
  }
}
</style>
